<dx-popup
    [title]="dialogHeader"
    [width]="400"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="job" validationGroup="rentalValidationGroup">
        @if (rentalJobs) {
            <dxi-form-item [label]="{ text: rentalJobLabel }" class="pb-3">
                <div *dxTemplate>
                    <dx-select-box [(value)]="selectedRentalJob" [dataSource]="rentalJobs" displayExpr="dumpster.size">
                        @if (rentalJobRequired) {
                            <dx-validator validationGroup="rentalValidationGroup">
                                <dxi-validator-validation-rule type="required"></dxi-validator-validation-rule>
                            </dx-validator>
                        }
                    </dx-select-box>
                </div>
            </dxi-form-item>
        }
        <dxi-form-item itemType="group" [colCount]="2">
            @if (dumpsters && isExchange) {
                <dxi-form-item
                    class="pb-3"
                    dataField="exchangeDumpsterId"
                    [label]="{ text: 'Pickup Dumpster' }"
                    editorType="dxSelectBox"
                    [editorOptions]="{
                        dataSource: dumpsters,
                        valueExpr: 'id',
                        displayExpr: 'size',
                        onValueChanged: dumpsterChanged
                    }"
                >
                    @if (dumpsterRequired) {
                        <dxi-form-validation-rule type="required"></dxi-form-validation-rule>
                    }
                </dxi-form-item>
            }
            @if (dumpsters && isExchange) {
                <dxi-form-item
                    [visible]="isDifferentThanRental && isExchange"
                    class="pb-3"
                    dataField="billExchangeAs"
                    [label]="{ text: 'Bill As' }"
                    editorType="dxSelectBox"
                    [editorOptions]="{
                        dataSource: dumpsters,
                        valueExpr: 'id',
                        displayExpr: 'size'
                    }"
                >
                    @if (dumpsterRequired) {
                        <dxi-form-validation-rule type="required"></dxi-form-validation-rule>
                    }
                </dxi-form-item>
            }
            @if (dumpsters && isExchange && !isDifferentThanRental && !isService) {
                <dxi-form-item itemType="empty"> </dxi-form-item>
            }
            @if (dumpsters && !isService) {
                <dxi-form-item
                    class="pb-3"
                    dataField="dumpsterId"
                    [label]="{ text: dumpsterLabel }"
                    editorType="dxSelectBox"
                    [editorOptions]="{
                        dataSource: dumpsters,
                        valueExpr: 'id',
                        displayExpr: 'size',
                        onValueChanged: dumpsterChanged
                    }"
                >
                    @if (dumpsterRequired) {
                        <dxi-form-validation-rule type="required"></dxi-form-validation-rule>
                    }
                </dxi-form-item>
            }
            @if (dumpsters) {
                <dxi-form-item
                    [visible]="isDifferentThanRental"
                    class="pb-3"
                    dataField="billAsDumpsterId"
                    [label]="{ text: 'Bill As' }"
                    editorType="dxSelectBox"
                    [editorOptions]="{
                        dataSource: dumpsters,
                        valueExpr: 'id',
                        displayExpr: 'size'
                    }"
                >
                    @if (dumpsterRequired) {
                        <dxi-form-validation-rule type="required"></dxi-form-validation-rule>
                    }
                </dxi-form-item>
            }
        </dxi-form-item>
        <dxi-form-item itemType="group" class="align-items-center" [colCount]="3">
            <dxi-form-item
                dataField="startDate"
                editorType="dxDateBox"
                [editorOptions]="{ onValueChanged: startDateChanged }"
                [colSpan]="2"
            >
                <dxi-form-validation-rule type="required"></dxi-form-validation-rule>
            </dxi-form-item>
            <dxi-form-item class="flex-fill">
                <div *dxTemplate class="d-flex">
                    <button class="btn-small btn-secondary mx-auto mt-3" (click)="toggleStartDate()">
                        {{ showTomorrowButton ? 'Tomorrow' : 'Today' }}
                    </button>
                </div>
            </dxi-form-item>
        </dxi-form-item>
        @if (showPreferredTime) {
            <dxi-form-item itemType="group" [colCount]="2">
                <dxi-form-item
                    dataField="preferredStartTime"
                    editorType="dxDateBox"
                    [label]="{ text: 'Preferred Start' }"
                    [editorOptions]="{ type: 'time', pickerType: 'list', onValueChanged: startTimeValueChanged }"
                ></dxi-form-item>
                <dxi-form-item
                    dataField="preferredEndTime"
                    editorType="dxDateBox"
                    [label]="{ text: 'Preferred End' }"
                    [editorOptions]="{ type: 'time', pickerType: 'list', onValueChanged: endTimeValueChanged }"
                ></dxi-form-item>
            </dxi-form-item>
        }
        <dxi-form-item
            class="pb-3"
            dataField="customerRequestedDumpsterId"
            [label]="{ text: 'Customer Preferred Dumpster' }"
            editorType="dxSelectBox"
            [editorOptions]="{
                dataSource: dumpsters,
                valueExpr: 'id',
                displayExpr: 'size'
            }"
        ></dxi-form-item>
        <dxi-form-item dataField="notes" editorType="dxTextArea" [label]="{ text: 'Site Notes' }" [editorOptions]="{ height: '100px' }">
        </dxi-form-item>
        <dxi-form-item dataField="driverNotes" editorType="dxTextArea" [editorOptions]="{ height: '100px' }"> </dxi-form-item>
    </dx-form>
</dx-popup>
